function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgOptimism = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icon",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M24 36.22v8.967c-9.224 0-16.703-7.48-16.703-16.703 0-9.224 7.48-16.704 16.703-16.704V2.813c9.224 0 16.703 7.48 16.703 16.703 0 9.224-7.48 16.704-16.703 16.704Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 0C10.746 0 0 10.746 0 24s10.746 24 24 24 24-10.746 24-24S37.254 0 24 0Zm0 36.22v8.967c-9.224 0-16.703-7.48-16.703-16.703 0-9.224 7.48-16.704 16.703-16.704V2.813c9.224 0 16.703 7.48 16.703 16.703 0 9.224-7.48 16.704-16.703 16.704Zm8.264-12.297v.154c-3.643 1.815-6.372 4.544-8.187 8.187h-.154c-1.815-3.643-4.544-6.372-8.187-8.187v-.154c3.643-1.815 6.372-4.544 8.187-8.187h.154c1.815 3.643 4.544 6.372 8.187 8.187Z",
    style: {
      fill: "#ff0420"
    }
  }));
};
export default SvgOptimism;